// extracted by mini-css-extract-plugin
export default {"main":"style_main__PT5UG","aside":"style_aside__w05eq","asideRight":"style_asideRight__PLZJO"};